var _excluded = ["label", "justification", "alignment", "tabColour", "tabCountColour", "tabInactiveColour", "tabBorderColour", "hoverColour", "labelMobile", "totalCount", "className", "renderZeroCount"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { MediaContext } from 'react-media-query-hoc';
import stylesFactory from './tab-item.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var TabItem = _ref => {
  var label = _ref.label,
    justification = _ref.justification,
    alignment = _ref.alignment,
    tabColour = _ref.tabColour,
    tabCountColour = _ref.tabCountColour,
    tabInactiveColour = _ref.tabInactiveColour,
    tabBorderColour = _ref.tabBorderColour,
    hoverColour = _ref.hoverColour,
    labelMobile = _ref.labelMobile,
    totalCount = _ref.totalCount,
    className = _ref.className,
    renderZeroCount = _ref.renderZeroCount,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useContext = useContext(MediaContext),
    _useContext$mobile = _useContext.mobile,
    mobile = _useContext$mobile === void 0 ? true : _useContext$mobile;
  var styles = stylesFactory({
    alignment,
    justification,
    tabColour,
    tabCountColour,
    hoverColour,
    tabBorderColour,
    tabInactiveColour
  });
  return ___EmotionJSX("span", _extends({
    className: className,
    css: styles.container
  }, otherProps), ___EmotionJSX("span", {
    css: styles.item
  }, mobile ? labelMobile || label : label, (totalCount || renderZeroCount) && ___EmotionJSX("span", {
    "data-test-id": "item-count",
    css: styles.itemCount
  }, totalCount)));
};
TabItem.propTypes = {
  label: PropTypes.string.isRequired,
  labelMobile: PropTypes.string,
  totalCount: PropTypes.number,
  className: PropTypes.string,
  renderZeroCount: PropTypes.bool,
  justification: PropTypes.oneOf(['left', 'right', 'full', 'auto']).isRequired,
  alignment: PropTypes.oneOf(['left', 'centre']).isRequired,
  tabBorderColour: PropTypes.string,
  tabColour: PropTypes.string,
  hoverColour: PropTypes.string,
  tabInactiveColour: PropTypes.string,
  tabCountColour: PropTypes.string
};
TabItem.defaultProps = {
  tabBorderColour: undefined,
  tabInactiveColour: undefined,
  tabColour: undefined,
  labelMobile: null,
  totalCount: 0,
  className: null,
  renderZeroCount: false,
  hoverColour: undefined,
  tabCountColour: undefined
};
export default TabItem;